import api from "../index";
import { qs } from "../../utils/utils";

export const LoginApi = (data) => api.post('authentication/login', data);
export const OtpApi = (data) => api.post('authentication/login-verify-otp', data);
export const SendOtpApi = (data) => api.post('authentication/login-resend-otp', data);
export const LogoutApi = (data) => api.post('authentication/logout', data);
export const ForgetPasswordApi = (data) => api.post('authentication/send-otp-email', data);
export const ForgetOtpApi = (data) => api.post('authentication/forgot-password-verify-otp', data);
export const GetUserPermissionApi = (id) => api.get(`rolepermission/modules-permission-by-user/${id}`);
export const ResetPasswordApi = (data) => api.post('authentication/forgot-password', data);

export const GetNotificationApi = () => api.get('notification/get-user-messages');
export const ClearNotificationApi = () => api.delete(`notification/admin/clear-all-notifications`);
export const MarkAsReadNotificationApi = (params) => api.put('notification/update-notification-status', params);

export const ChangePasswordApi = (data) => api.post("authentication/admin/change-password", data);

export const Request2faChangeApi = (params) => api.put(`usermaster/request-2fa-change?${qs(params)}`);
export const Verify2faChangeApi = (data) => api.put('usermaster/verify-2fa-change', data);
